'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://lit-depths-24307.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client9.js